import { all, call, put, takeLatest, select } from "redux-saga/effects";

import actions from "../../constants/actions";
import { GET, POST } from "../../utils/api";
import { getLocale } from "../selectors/app";

function _buildFormData(formData, data, parentKey) {
    if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
    ) {
        Object.keys(data).forEach((key) => {
            _buildFormData(
                formData,
                data[key],
                parentKey ? `${parentKey}[${key}]` : key
            );
        });
    } else {
        const value = data == null ? "" : data;

        formData.append(parentKey, value);
    }
}

export function* getActiveOpenCalls({ payload }) {
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url: "api/open_calls",
            locale,
        });

        yield put({
            type: actions.OPEN_CALLS.LOAD_ACTIVE_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.OPEN_CALLS.LOAD_ACTIVE_FAIL,
            payload: error,
        });
    }
}

export function* getOpenCallApplications({ payload }) {
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url: "api/open_call_applications",
            locale,
        });

        yield put({
            type: actions.OPEN_CALLS.LOAD_APPLICATIONS_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.OPEN_CALLS.LOAD_APPLICATIONS_FAIL,
            payload: error,
        });
    }
}

export function* addOpenCallApplications({ payload }) {
    const locale = yield select(getLocale);

    let formData = new FormData();
    _buildFormData(formData, payload.data);

    try {
        let response = yield call(POST, {
            url: "api/open_call_applications/" + payload.id,
            data: formData,
            locale,
        });

        yield put({
            type: actions.OPEN_CALLS.CREATE_APPLICATIONS_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.OPEN_CALLS.CREATE_APPLICATIONS_FAIL,
            payload: error,
        });
    }
}

export function* addOpenCallDynamicApplications({ payload }) {
    const locale = yield select(getLocale);

    let formData = new FormData();
    _buildFormData(formData, payload.data);

    try {
        let response = yield call(POST, {
            url: "api/open_call_applications/dynamic/" + payload.id,
            data: formData,
            locale,
        });

        yield put({
            type: actions.OPEN_CALLS.CREATE_DYNAMIC_APPLICATIONS_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.OPEN_CALLS.CREATE_DYNAMIC_APPLICATIONS_FAIL,
            payload: error,
        });
    }
}

export default function* OpenCalls() {
    yield all([
        yield takeLatest(actions.OPEN_CALLS.LOAD_ACTIVE, getActiveOpenCalls),
        yield takeLatest(
            actions.OPEN_CALLS.LOAD_APPLICATIONS,
            getOpenCallApplications
        ),
        yield takeLatest(
            actions.OPEN_CALLS.CREATE_APPLICATIONS,
            addOpenCallApplications
        ),
        yield takeLatest(
            actions.OPEN_CALLS.CREATE_DYNAMIC_APPLICATIONS,
            addOpenCallDynamicApplications
        ),
    ]);
}
